import {Component, ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import { MatRadioChange } from '@angular/material/radio';

@Component({
    standalone: false,
    selector: 'particle-add-report',
  templateUrl: './add-report.component.html',
  styleUrls: ['./add-report.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class AddReportComponent implements OnInit, IDialogView {
  data: DialogModel;
  constructor() {
  }

  ngOnInit() {
  }

  onOkClicked(): boolean {
    if (!this.data.input.title || this.data.input.title.length === 0) {
      return false;
    }
    if (!this.data.input.description || this.data.input.description === 0) {
      return false;
    }
    return true;
  }

  onChange($event: MatRadioChange) {

  }
}

